import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';

// Authentication check function - simple version that worked previously
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return token !== null;
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Login route */}
        <Route 
          path="/login" 
          element={
            isAuthenticated() ? 
              <Navigate to="/dashboard" /> : 
              <Login key={Date.now()} />
          } 
        />
        
        {/* Dashboard route - protected */}
        <Route
          path="/dashboard"
          element={
            <Dashboard />
          }
        />
        
        {/* Root route */}
        <Route 
          path="/" 
          element={<Navigate to="/dashboard" />} 
        />
        
        {/* Catch all unknown routes */}
        <Route 
          path="*" 
          element={<Navigate to="/dashboard" />} 
        />
      </Routes>
    </Router>
  );
};

export default App;